import { createContext, useContext } from 'react';

export interface ValidationEntry {
	result: string | null;
	accepted: boolean;
}

export interface ValidationContextType {
	isNextBlockedByValidation: boolean;
	hasNonCorrectValidation: boolean;
	getAccepted: (id: string) => boolean;
	setAccepted: (id: string, value: boolean) => void;
	setValidationResult: (id: string, result: string | null) => void;
	unregister: (id: string) => void;
}

export const ValidationContext = createContext<ValidationContextType | undefined>(undefined);

export const useValidation = () => {
	const context = useContext(ValidationContext);

	if (!context) throw new Error('useValidation must be used within ValidationProvider');

	return context;
};
